import { render, staticRenderFns } from "./HolidayDetail.vue?vue&type=template&id=10e4646c&scoped=true&"
import script from "./HolidayDetail.vue?vue&type=script&lang=js&"
export * from "./HolidayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e4646c",
  null
  
)

export default component.exports